// extracted by mini-css-extract-plugin
module.exports = {"register":"_37QYO5_JTg99Ib6b8xe4AS"};